export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "automatic_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listes automatiques"])},
        "create_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle liste"])},
        "my_company_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes listes d'entreprises"])},
        "my_contact_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes listes de contacts"])},
        "my_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes listes"])},
        "my_prospects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes prospects"])},
        "unsubscribed_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listes désinscrits"])}
      },
      "en": {
        "automatic_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Automatic lists"])},
        "create_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New list"])},
        "my_company_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My company lists"])},
        "my_contact_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My contact lists"])},
        "my_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My lists"])},
        "my_prospects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My prospects"])},
        "unsubscribed_lists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsubscribed lists"])}
      }
    }
  })
}
